import { countries } from '../countries'

export const getCountryCodeFromName = (countryName: string | undefined | null) => {
  const country = countries.find((c) => c.name === countryName || c.code === countryName)
  return country?.code
}
